export * from "./MainTemplate";
